// extracted by mini-css-extract-plugin
export default {"wrapper":"PaneHeader_wrapper__f31P8","blue":"PaneHeader_blue__w6Jxa"};